import { supabase } from './supabase'

export const AdImpactClient = {
  async list() {
    const { data, error } = await supabase
      .from('alert_clients')
      .select('*')
      .order('created_at', { ascending: false })
    if (error) throw error
    return data
  },

  async bulkCreate(records) {
    const { data, error } = await supabase
      .from('alert_clients')
      .insert(records)
      .select()
    if (error) throw error
    return data
  },

  async update(id, fields) {
    const { data, error } = await supabase
      .from('alert_clients')
      .update(fields)
      .eq('id', id)
      .select()
    if (error) throw error
    return data
  },

  async delete(id) {
    const { error } = await supabase
      .from('alert_clients')
      .delete()
      .eq('id', id)
    if (error) throw error
  },
}
